import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import StatusBadge from './StatusBadge';
import { daoLinkSx, monoValueStyles, primaryValueStyles } from '../css/revenueItems.styles';
import { formatDateTime, formatRevenueType, formatSourceType } from '../utils/revenueItems.utils';

const shortenHex = (hex, head = 10, tail = 8) => {
  if (!hex || typeof hex !== 'string') return '-';
  const s = hex.startsWith('0x') ? hex : `0x${hex}`;
  if (s.length <= head + tail + 2) return s;
  return `${s.slice(0, head + 2)}…${s.slice(-tail)}`;
};

const RevenueItemRow = ({ item, daoName, showBatchId = false, showDao = true, showOnchainRequestId = false }) => (
  <TableRow key={item._id} hover>
    {showDao && (
      <TableCell>
        <Typography sx={daoLinkSx}>{item.dao?.name || daoName}</Typography>
      </TableCell>
    )}
    <TableCell>
      <Typography sx={primaryValueStyles}>{formatRevenueType(item.revenueType)}</Typography>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>{formatSourceType(item.sourceType)}</Typography>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>
        {item.amount} {item.currency || 'USDT'}
      </Typography>
    </TableCell>
    <TableCell>
      <StatusBadge status={item.status} />
    </TableCell>
    {showBatchId && (
      <TableCell title={item.batchId}>
        <Typography sx={{ ...monoValueStyles, wordBreak: 'break-all' }}>
          {item.batchId ? shortenHex(String(item.batchId), 6, 4) : '—'}
        </Typography>
      </TableCell>
    )}
    {showOnchainRequestId ? (
      <TableCell>
        <Typography sx={{ ...monoValueStyles, wordBreak: 'break-all' }}>
          {item.onchainRequestId ?? '—'}
        </Typography>
      </TableCell>
    ) : (
      <TableCell title={item.memoHash}>
        <Typography sx={{ ...monoValueStyles, wordBreak: 'break-all' }}>{shortenHex(item.memoHash)}</Typography>
      </TableCell>
    )}
    <TableCell title={item.txHash}>
      <Typography sx={{ ...monoValueStyles, wordBreak: 'break-all' }}>{shortenHex(item.txHash)}</Typography>
    </TableCell>
    <TableCell title={item.fromAddress}>
      <Typography sx={{ ...monoValueStyles, wordBreak: 'break-all' }}>{shortenHex(item.fromAddress)}</Typography>
    </TableCell>
    <TableCell>
      <Typography sx={primaryValueStyles}>{formatDateTime(item.createdAt)}</Typography>
    </TableCell>
  </TableRow>
);

export default RevenueItemRow;
